export const LOGIN_BEGINS = 'LOGIN_BEGINS'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const TURNOFF_LOADER = 'TURNOFF_LOADER'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'